/**
 * List of events in the map sidebar
 */

import { Card } from '@/components/ui/card';
import { DatePopover } from '@/components/ui/date-popover';
import { Clock } from 'lucide-react';

interface EventMarkerData {
    event: HistoricalEventByPassage | HistoricalEvent;
    matchingPlace: GeographicEntity;
}

interface EventsListProps {
    eventMarkers: EventMarkerData[];
    onEventClick: (eventName: string, coordinates: { latitude: number; longitude: number }) => void;
}

export function EventsList({ eventMarkers, onEventClick }: EventsListProps) {
    if (eventMarkers.length === 0) {
        return null;
    }

    return (
        <div>
            <h3 className="text-sm font-semibold mb-3">
                Events ({eventMarkers.length})
            </h3>
            <div className="space-y-2">
                {eventMarkers.map((marker, index) => (
                    <Card
                        key={index}
                        className="p-3 cursor-pointer hover:bg-accent transition-colors"
                        onClick={() => onEventClick(marker.event.title, marker.matchingPlace.coordinates)}
                    >
                        <div className="space-y-1">
                            <div className="flex items-center gap-2">
                                <Clock className="h-4 w-4 text-muted-foreground" />
                                <span className="font-medium text-sm">{marker.event.title}</span>
                            </div>
                            <DatePopover
                                date={marker.event.date}
                                alternativeDates={marker.event.alternativeDates}
                                title="Event Date"
                            />
                        </div>
                    </Card>
                ))}
            </div>
        </div>
    );
}

